import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask3700To3799Service {

  constructor() { }
}
